<h1 mat-dialog-title>Partnerinfo</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <p>{{ data.name }}</p>
  <p>
    <span *ngIf="data.phone">T: {{ data.phone | dkPhoneNumber }}<br /></span>
    <a
      href="mailto:{{ data.email }}"
      class="ellipsis"
      title="Send mail til {{ data.email }}"
      >{{ data.email }}</a
    >
  </p>
</div>

<div mat-dialog-actions class="row-reverse">
  <button mat-raised-button color="primary" mat-dialog-close>Luk</button>
</div>
